const size = '16px';

export const ColorPreviewStyles = (props: any) => `
  margin-right: 8px;
  display: ${props.hex ? 'flex' : 'none'};
  background: ${props.hex || 'transparent'};
  width: ${size};
  height: ${size};
  border-radius: 8px;
`;
